import { configureStore } from "@reduxjs/toolkit";
import tokenSlice from "./slices/tokenSlice";
import sidebarSlice from "./slices/sidebarSlice";
import drawerSlice from "./slices/drawerSlice";

const store = configureStore({
  reducer: {
    tokenSlice: tokenSlice.reducer,
    sidebarSlice: sidebarSlice.reducer,
    drawerSlice: drawerSlice.reducer
  },
});

export default store;